import React from 'react';

const PanelMain = (props) => (
  <main className='panel_main' {...props} />
);

export default PanelMain;
